import React from 'react';
import { ArrowRight } from 'lucide-react';

const SalonConcept: React.FC = () => {
  const SELECTED_IMAGE = 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4';

  const navigateToArchive = () => {
    window.dispatchEvent(new CustomEvent('navigate', { detail: 'archive' }));
  };

  return (
    <section id="salon" className="py-24 md:py-40 bg-white px-6">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-20 items-center">
        <div className="relative group">
          <div className="relative overflow-hidden rounded-lg shadow-2xl bg-neutral-100 min-h-[400px]">
            <img 
              src={`${SELECTED_IMAGE}?auto=format&fit=crop&q=80&w=1200`} 
              alt="A modern collaborative space where community meaning is constructed" 
              className="w-full h-full object-cover grayscale brightness-90 contrast-125 transition-all duration-1000 group-hover:grayscale-0 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-terracotta/5 mix-blend-multiply opacity-50 pointer-events-none" />
          </div>
          
          <div className="absolute -bottom-6 -left-6 bg-terracotta text-white p-6 md:p-10 max-w-[240px] shadow-2xl z-10 transform -rotate-2 group-hover:rotate-0 transition-transform duration-500">
             <p className="text-sm font-black tracking-tight leading-snug uppercase italic text-white">Dialogue is the engine of progress.</p>
          </div>
          
          <div className="absolute inset-0 border border-charcoal/5 -m-4 rounded-lg -z-10 group-hover:m-0 transition-all duration-700" />
        </div>
        
        <div className="space-y-10">
          <div className="space-y-4">
            <h2 className="text-5xl md:text-7xl tracking-tighter leading-[0.95] font-black">The Modern Salon</h2>
            <p className="text-xl md:text-2xl font-bold tracking-tight text-charcoal">
              A shared moment where meaning is constructed.
            </p>
          </div>
          
          <div className="text-lg md:text-xl text-neutral-800 leading-relaxed font-normal space-y-6">
            <p>
              Vibe with AI Salons are the community arm of Vibe with AI, designed as structured environments for thoughtful, high-stakes idea exchange.
            </p>
            <p>
              Following our successful inaugural event at Benedictine University, we are preparing the next series of gatherings for Spring 2026.
            </p>
            <button 
              onClick={navigateToArchive}
              className="group flex items-center gap-4 text-[10px] font-black uppercase tracking-[0.4em] text-terracotta hover:text-charcoal transition-colors border-b-2 border-terracotta/20 pb-2"
            >
              See what happened at Salon I
              <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
          
          <div className="space-y-4 border-t-2 border-neutral-100 pt-8 relative">
            <span className="text-xs font-black uppercase tracking-[0.3em] text-terracotta block mb-2">
              The Pedigree 
            </span>
            <p className="text-neutral-700 text-sm md:text-base leading-relaxed">
              Founded by <span className="text-charcoal font-bold">Arthur Zards</span>, creator of <span className="text-charcoal font-bold">TEDxNaperville</span>, with over a decade of experience curating conversations that change how people think and act.
            </p>
          </div>

          <div className="pt-4 flex flex-wrap gap-8 items-start">
            <div className="space-y-1">
              <span className="block text-3xl font-black tracking-tighter text-charcoal leading-tight">15+</span>
              <span className="text-[10px] uppercase tracking-widest font-bold text-neutral-500">Years of live curation</span>
            </div>
            <div className="space-y-1">
              <span className="block text-3xl font-black tracking-tighter text-charcoal uppercase leading-tight">Labs</span>
              <span className="text-[10px] uppercase tracking-widest font-bold text-neutral-500">Hands-on experimentation</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SalonConcept;